import { render, staticRenderFns } from "./ReviewExerciseGrid.vue?vue&type=template&id=92cbd30a"
import script from "./ReviewExerciseGrid.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports